<template>
  <form class="row" @submit.prevent="createChannel()">
    <div class="small-12 medium-8 columns">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option :value="item.id" v-for="item in providerOptions" :key="item.id">
            {{ item.title }}
          </option>
          <!-- <option value="sid">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.SIP') }}
          </option> -->
        </select>
      </label>
    </div>

    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.PLACEHOLDER')
          "
          @blur="$v.inboxName.$touch"
        />
        <span v-if="$v.inboxName.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.LABEL') }}
        <input
          v-model.trim="phoneNumber"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.PLACEHOLDER')
          "
          @blur="$v.phoneNumber.$touch"
        />
        <span v-if="$v.phoneNumber.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.ERROR')
        }}</span>
      </label>
    </div>


    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.sip_gateway.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SIP.SIP_GATEWAY.LABEL') }}
        <input
          v-model.trim="sip_gateway"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.SIP.SIP_GATEWAY.PLACEHOLDER')
          "
          @blur="$v.sip_gateway.$touch"
        />
        <span v-if="$v.sip_gateway.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SIP.SIP_GATEWAY.ERROR')
        }}</span>
      </label>
    </div>

    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.sip_username.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SIP.USERNAME.LABEL') }}
        <input
          v-model.trim="sip_username"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.SIP.USERNAME.PLACEHOLDER')"
          @blur="$v.sip_username.$touch"
        />
        <span v-if="$v.sip_username.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SIP.USERNAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.sip_password.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SIP.PASSWORD.LABEL') }}
        <input
          v-model.trim="sip_password"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.SIP.PASSWORD.PLACEHOLDER')
          "
          @blur="$v.sip_password.$touch"
        />
        <span v-if="$v.sip_password.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SIP.PASSWORD.ERROR')
        }}</span>
      </label>
    </div>

    <div class="small-12 medium-12 columns">
      <woot-submit-button
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.SMS.SIP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';

const shouldStartWithPlusSign = (value = '') => value.startsWith('+');

export default {
  mixins: [alertMixin],
  data() {
    return {
      sip_username: '',
      sip_password: '',
      sip_gateway: '',
      inboxName: '',
      phoneNumber: '',
      provider:"redtone",
      providerOptions:[
        {
          id:"redtone",
          title:"Redtone"
        },
        {
          id:"myvoip",
          title:"MyVoip"
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      globalConfig: 'globalConfig/get',
    }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, shouldStartWithPlusSign },
    sip_username: { required },
    sip_password: { required },
    sip_gateway: { required },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const smsChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName,
          channel: {
            type: 'sip',
            phone_number: this.phoneNumber,
            sip_gateway: this.sip_gateway,
            provider: this.provider,
            provider_config: {
              sip_username: this.sip_username,
              sip_password: this.sip_password,
            },
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: smsChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.SMS.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>
